<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>{{ titulo }}</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-spinner v-if="cargando"></v-spinner>
    <v-card-text
      style="max-height: 100%;"
      v-else
    >
      <v-alert
        v-model="alerta.mostrar"
        dismissible
        :type="alerta.tipo"
      >
        {{ alerta.mensaje }}
      </v-alert>

      <v-container grid-list-md>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm3
          >
            <v-select
              v-model="itemSeleccionado.punto_venta_id"
              :items="info.puntosVentas"
              item-text="numero"
              item-value="id"
              label="Punto de vta."
              @change="alCambiarPuntoVenta"
              v-validate="{ required: campoRequerido('punto_venta_id') }"
              :data-vv-name="'punto_venta_id'"
              :error-messages="errors.collect('punto_venta_id')"
              data-vv-validate-on="blur"
            ></v-select>
          </v-flex>

          <v-flex
            xs12
            sm3
          >
            <v-select
              v-model="itemSeleccionado.tipo_comprobante_categoria_id"
              :items="info.categoriasTipoComprobantes"
              item-text="nombre"
              item-value="id"
              label="Letra"
              v-validate="{ required: campoRequerido('tipo_comprobante_categoria_id') }"
              :data-vv-name="'tipo_comprobante_categoria_id'"
              :error-messages="errors.collect('tipo_comprobante_categoria_id')"
              data-vv-validate-on="blur"
            ></v-select>
          </v-flex>

          <v-flex
            xs12
            sm3
          >
            <v-text-field
              v-model="itemSeleccionado.numero_comprobante"
              label="Número"
              v-validate="{ required: campoRequerido('numero_comprobante') }"
              :data-vv-name="'numero_comprobante'"
              :error-messages="errors.collect('numero_comprobante')"
              data-vv-validate-on="blur"
            ></v-text-field>
          </v-flex>

          <v-flex
            xs12
            sm3
          >
            <v-text-field
              type="date"
              v-model="itemSeleccionado.fecha"
              label="Fecha"
              v-validate="{ required: campoRequerido('fecha') }"
              :data-vv-name="'fecha'"
              :error-messages="errors.collect('fecha')"
              data-vv-validate-on="blur"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="puedo(operacion)"
        v-bind:guardando="guardando"
        v-on:alGuardar="guardar"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import Combo from '@/api/combo'
import abmFormularioMixin from '@/mixins/abmFormulario'
import _ from 'lodash'

export default {
  name: 'FacturacionCentroCambioPLNComprobante',
  mixins: [abmFormularioMixin],
  computed: {},
  data () {
    return {
      montarMixin: false,
      info: {
        instituciones: [],
        puntosVentas: [],
        categoriasTipoComprobantes: []
      },
      puntoVentaSeleccionado: null
    }
  },
  mounted () {
    let vm = this

    vm.modeloApi.obtener(vm.item.id).then(data => {
      data.origen = 'centro'
      vm.itemSeleccionado = _.cloneDeep(data)

      vm.cargarInfo()
    })
  },
  methods: {
    cargarInfo () {
      let vm = this

      let cargaOrigen = 'edicion'

      let dataCombos = {
        instituciones: {
          ids: [vm.item.institucion.id],
          relaciones: ['puntosVenta']
        },
        grupoEntidades: {
          categoriasTipoComprobantes: {
            codigo: 'tipo_comprobante_categoria',
            itemVacio: true
          }
        }
      }

      if (vm.itemSeleccionado.id > 0) {
        cargaOrigen = 'edicion'
      }

      vm.cargarCombos(dataCombos, cargaOrigen)
    },

    alCambiarPuntoVenta () {
      let vm = this

      if (vm.itemSeleccionado.punto_venta_id) {
        vm.puntoVentaSeleccionado = _.find(vm.institucionSeleccionada.puntos_venta, {
          id: vm.itemSeleccionado.punto_venta_id
        })
      }
    },

    cargarCombos (dataCombos, cargaOrigen) {
      let vm = this
      Combo.listado(dataCombos).then(
        data => {
          vm.info = _.assign(vm.info, data)

          switch (cargaOrigen) {
            case 'edicion':
              vm.institucionSeleccionada = _.find(vm.info.instituciones, {
                id: vm.itemSeleccionado.institucion_id
              })
              vm.puntoVentaSeleccionado = _.find(vm.institucionSeleccionada.puntos_venta, {
                id: vm.itemSeleccionado.punto_venta_id
              })

              vm.$set(vm.info, 'puntosVentas', vm.institucionSeleccionada.puntos_venta)

              break
          }

          vm.cargando = false
        },
        error => {
          vm.mostrarError(error)
          vm.cargando = false
        }
      )
    },

    campoRequerido (campo) {
      let requerido = true
      return requerido
    },
    metodoGuardar (datos) {
      var datosFinales = {
        punto_venta_id: datos.punto_venta_id,
        tipo_comprobante_categoria_id: datos.tipo_comprobante_categoria_id,
        numero_comprobante: datos.numero_comprobante,
        fecha: datos.fecha
      }
      return this.modeloApi.cambiarPLN(datos.id, datosFinales)
    }
  }
}
</script>

<style lang="scss" scoped></style>
